<template>
  <div>
    <h5 class="info-text">List of Investigation Report</h5>
    <div class="row justify-content-center mt-5">
      <div class="col-sm-10">
        <el-table
          :data="tableJKKP"
          max-height="500"
          @selection-change="handleRowChange"
          style="border: solid white; border-radius: 10px"
          :header-cell-style="{
            background: 'transparent',
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
          :cell-style="{
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
        >
          <el-table-column
            min-width="140"
            sortable
            align="center"
            label="Date of Investigation"
            property="dateOfInvestigation"
          ></el-table-column>
          <el-table-column
            min-width="200"
            sortable
            align="center"
            label="Control Case No"
            property="controlCaseNo"
          ></el-table-column>
          <!-- <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Staff No"
            property="staffNo"
          ></el-table-column> -->
          <!-- <el-table-column
            min-width="110"
            sortable
            align="center"
            label="Type of Incident"
            property="incidentType"
          ></el-table-column> -->
          <el-table-column
            type="selection"
            :min-width="40"
            align="right"
            :disabled="isShow"
          >
            <!-- <div slot-scope="props">
              <base-input type="checkbox" @click="handleRowChange(props.row)" >
              </base-input>
            </div> -->
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      tableJKKP: [],
      model: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
      },
      modelValidations: {
        firstName: {
          required: true,
          min: 5,
        },
        lastName: {
          required: true,
          min: 5,
        },
        email: {
          required: true,
          email: true,
        },
        phone: {
          required: true,
          numeric: true,
        },
        instid: "",
        isShow: false,
        data: [],
      },
    };
  },
  created() {
    this.getInvestigation();
  },
  methods: {
    getInvestigation() {
      this.$http.get(":9994/api/v1/incident/investigationlist").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.tableJKKP = [];
          for (var i = 0; i < response.length; i++) {
            let data = {
              instid: response[i].InstId,
              dateOfInvestigation: response[i].InstDate,
              officerName: response[i].InstName,
              staffNo: response[i].InstStaffId,
              controlCaseNo: response[i].ControlCaseNo,
              // incidentType: response[i].InName
            };

            this.tableJKKP.push(data);
          }
        }
      });
    },
    handleRowChange(val) {
      console.log(val);
      this.data = val;
      // if(val.length === 1){
      // this.instid = val[0].instid
      // console.log(this.instid)
      // } else if(val.length == 0){

      // } else {
      // disable button
      //   this.disableBtn()
      // }

      // val = []
      // this.disableBtn()
    },
    disableBtn() {
      // this.tableJKKP.forEach((val,inx) => {
      //     this.tableJKKP[inx].isShow = true
      //     console.log('val::',val)
      //     console.log('inx::',inx)
      // })
      // this.multipleSelection.forEach((item,index) => {
      //     console.log('itme::',item)
      //     console.log('index::',index)
      // })
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      // let instid = row.instid
      console.log(this.data);
      console.log(this.data[0].instid);

      if (this.data.length === 1) {
        let instid = this.data[0].instid;
        return this.$validator.validateAll().then((res) => {
          this.$root.$emit("instid", instid);
          return res;
        });
      } else {
        swal({
          title: "Only single select allow!",
          // text: `You deleted ${row.InstName}`,
          type: "info",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false,
        });
      }
    },
  },
};
</script>
<style></style>
